import { buildModelManager } from "../builder.js";
const DefaultAttendanceMagicLinkTokenSelection = {
  __typename: true,
  id: true,
  actionType: true,
  createdAt: true,
  errorMessage: true,
  expiresAt: true,
  sentAt: true,
  shiftDocumentationId: true,
  shiftId: true,
  studentId: true,
  token: true,
  updatedAt: true,
  usedAt: true,
  usedByIp: true,
  usedByLatitude: true,
  usedByLongitude: true,
  wasSuccessful: true
};
const modelApiIdentifier = "attendanceMagicLinkToken";
const pluralModelApiIdentifier = "attendanceMagicLinkTokens";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAttendanceMagicLinkTokenSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAttendanceMagicLinkTokenSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceMagicLinkTokenSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceMagicLinkTokenSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceMagicLinkTokenSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceMagicLinkTokenSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceMagicLinkTokenSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByToken",
    findByField: "token",
    findByVariableName: "token",
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceMagicLinkTokenSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByToken",
    findByField: "token",
    findByVariableName: "token",
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceMagicLinkTokenSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "attendanceMagicLinkTokenGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AttendanceMagicLinkTokenManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAttendanceMagicLinkTokenSelection,
  operations
);
export {
  AttendanceMagicLinkTokenManager,
  DefaultAttendanceMagicLinkTokenSelection
};
//# sourceMappingURL=AttendanceMagicLinkToken.js.map
